function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.6484 13.1L21.2218 11.377C21.677 11.2735 22 10.8688 22 10.4019V7.25C22 6.69772 21.5523 6.25 21 6.25H3C2.44772 6.25 2 6.69772 2 7.25V10.4019C2 10.8688 2.32298 11.2735 2.77817 11.377L10.3516 13.1",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 11,
  width: 4,
  height: 4,
  rx: 1
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 11,
  width: 4,
  height: 4,
  rx: 1,
  stroke: "#627080",
  strokeWidth: 3,
  mask: "url(#path-2-inside-1)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.45 6.25V4C15.45 3.44772 15.0023 3 14.45 3H9.54999C8.9977 3 8.54999 3.44772 8.54999 4V6.25",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.60001 11.375V19.125C2.60001 19.6773 3.04772 20.125 3.60001 20.125H20.35C20.9023 20.125 21.35 19.6773 21.35 19.125V11.375",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgBusinessCenter2 = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBusinessCenter2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Business-center-2.8994189a.svg";
export { ForwardRef as ReactComponent };